// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".css__qr_scanner___3xxqg div {\n    box-shadow: hsla(var(--color-primary-hsl), 50%) 0px 0px 0px 5px inset;\n}\n\n.css__qr_scanner_loader___2aC-g {\n    margin-right: auto;\n    margin-left: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}", ""]);
// Exports
exports.locals = {
	"qr_scanner": "css__qr_scanner___3xxqg",
	"qr_scanner_loader": "css__qr_scanner_loader___2aC-g"
};
module.exports = exports;
